import { getDateByTimezone } from 'utils/utils'

import useOrderHistory from 'hooks/order/useOrderHistory'

import OrderHistorySection from 'components/presenters/commerce/order/orderHistoryList/OrderHistorySection'
import OrderHistoryItem from 'components/presenters/commerce/order/orderHistoryList/OrderHistoryItem'
import OrderItemHeader from 'components/presenters/commerce/order/OrderItemHeader'
import OrderItemBlock from 'components/presenters/commerce/order/orderHistoryList/OrderItemBlock'
import OrderItem from 'components/presenters/commerce/order/OrderItem'
import OrderHistoryItemFooterActionBtn from 'components/presenters/commerce/order/orderHistoryList/OrderHistoryItemFooterActionBtn'
import ChallengeProcessBtn from 'components/presenters/commerce/order/orderHistoryList/ChallengeProcessBtn'
import OrderEmpty from 'components/presenters/commerce/order/orderHistoryList/OrderEmpty'

export default function OrderHistoryContainer() {
  const { orders, getFooterActionProps, handleClickOrderDetail } = useOrderHistory()
  return Array.isArray(orders) && orders.length > 0 ? (
    <OrderHistorySection>
      {orders.map((order) => (
        <OrderHistoryItem key={`order-no-${order.no}`}>
          <OrderItemHeader
            orderNo={order.no}
            orderDate={getDateByTimezone('Asia/Seoul', new Date(order.create_date), '.')}
            onClick={() => handleClickOrderDetail(order.no)}
          />

          {Array.isArray(order.order_items) &&
            order.order_items.map((item) => (
              <OrderItemBlock key={`order-item-no-${item.no}`}>
                <OrderItem
                  isChallenge={item.is_challenge}
                  bannerImg={item.product.banner_img}
                  title={item.product.title}
                  optionName={item.archived_sku?.name}
                  unitPrice={item.unit_price}
                  quantity={item.quantity}
                  challengeUnitPrice={item.challenge_unit_price}
                />
                <OrderHistoryItemFooterActionBtn {...getFooterActionProps(item)} />
                {item.is_challenge && <ChallengeProcessBtn />}
              </OrderItemBlock>
            ))}
        </OrderHistoryItem>
      ))}
    </OrderHistorySection>
  ) : (
    <OrderEmpty />
  )
}
